module.exports = __webpack_public_path__ + "static/img/arrow-up.e555f79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-up.png
// module id = inxr
// module chunks = 1